import * as _ from "lodash";
import { IBusinessObject, IBusinessObjectChanges, IBusinessObjectChangesOptions } from "../PA.Core/PA.Core.IF.BO";
import { IDateRange, IMessageProvider, IProgressProvider, MessageType } from "../PA.Core/PA.Core.IF.Basic";
import { PAdbContext } from "../PA.Core/PAdbContext";
import { IdentityProvider } from "../PA.Core/Basic/Identity";
import { MessageProvider } from "../PA.Core/Basic/Messages";
import { ProgressProvider } from "../PA.Core/Basic/Progress";
import {
    WB_ConnectionRow,
    WB_CustomerRow,
    WB_EventPortfolioCustomerRelationshipRow,
    WB_EventPortfolioEventTypeRelationshipRow,
    WB_EventPortfolioLinkedAnalysisRelationshipRow,
    WB_EventPortfolioLinkedAnalysisRow,
    WB_EventPortfolioPeriodRelationshipRow,
    WB_EventPortfolioProductRelationshipRow,
    WB_EventPortfolioRelationshipRow,
    WB_EventPortfolioRow,
    WB_EventPortfolioTagRelationshipRow,
    WB_EventRow,
    WB_EventTagRow,
    WB_EventTypeRow,
    WB_PeriodRow, WB_PlanManagementRow,
    WB_ProductGroupRow,
    WB_ReportTileRow, WB_SalesOrgRow, WB_SearchProfileRow,
    WB_TagRelationshipRow,
    WB_TagRow
} from "../PA.Core/PAdbSchemaRows";
import { IwbEventPortfolio } from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Company,
    esWB_Connection,
    esWB_Customer,
    esWB_Event,
    esWB_Event_Portfolio,
    esWB_Event_Portfolio_Customer_Relationship,
    esWB_Event_Portfolio_EventType_Relationship,
    esWB_Event_Portfolio_LinkedAnalysis,
    esWB_Event_Portfolio_LinkedAnalysis_Relationship,
    esWB_Event_Portfolio_Period_Relationship,
    esWB_Event_Portfolio_Product_Relationship,
    esWB_Event_Portfolio_Relationship,
    esWB_Event_Portfolio_Tag_Relationship,
    esWB_Event_Tag,
    esWB_Event_Type,
    esWB_Period,
    esWB_Product_Group, esWB_Product_Group_SalesArea,
    esWB_ReportTile, esWB_SalesOrg, esWB_Search_ProfileCR, esWB_Search_ProfileFCR, esWB_Search_ProfileGCR,
    esWB_Tag,
    esWB_Tag_Relationship, esWB_User_Group_Product
} from "../PA.Core/PAdbSchema";
import { ESRecord } from "../PA.Core/lib/ESRecord";
import { ESDataStore } from "../PA.Core/lib/ESDataStore";
import { CreateOptions, ESRecordResolver } from "../PA.Core/lib/ESRecordResolver";
import { ASync } from "../PA.Core/Basic/ASync";

import { PAEnvironment } from "../PA.Core/PAEnvironment";
import { CustomerHierarchyService } from "../PA.MD.Services/CustomerHierarchyService";
import { DateUtils } from "../PA.Core/Basic/Dates";
import { ProductHierarchyService } from "../PA.MD.Services/ProductHierarchyService";
import { PASearch } from "../PA.Core/PASearch";
import { BehaviorSubject } from "rxjs";
import { EventCollection } from "../PA.TPM.Core/EventCollection";
import { IHaveSecurity, IHaveTags } from "../PA.Core/PA.Core.IF.Aspects";
import { TagBag } from "../PA.Utils/TagBag";
import { EventPortfolioBOValidation } from "./EventPortfolioBO.validation";
import { PAusrContext } from "../PA.Core/PAusrContext";
import { IPolicyCollection } from "../PA.Core/PA.Core.IF.Policy";
import { PolicyCollection } from "../PA.Core/Security/PolicyCollection";
import { ILock } from "../PA.Concurrency.Core/PA.Concurrency.IF.Lock";
import { EventPortfolioBOStandardPolicy } from "./EventPortFolioBO.StdPolicy";
import { RecordUtils } from "../PA.Core/Basic/Records";
import { DefaultChanges } from "../PA.Core/BusinessObject/BusinessObjectChanges";
import { MDUsageService } from "../PA.MD.Services/MDUsageService";

interface IPortfolioEventTypeRel {
    EventTypeRow: WB_EventTypeRow,
    Included_Ind: boolean
}


export class EventPortfolioBO
    implements IBusinessObject,

        IHaveSecurity {
    Identity: IdentityProvider;

    CreateOptions: any;
    CopyOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    ProcessProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_EventPortfolio: WB_EventPortfolioRow;
    peaCount: number;
    bmCount: number;

    _bShowEDLP: boolean;
    _bShowEDLC: boolean;
    _bShowShipper: boolean;
    _bShowSpecialPack: boolean;
    _bShowMerch: boolean;
    _bShowOther: boolean;

    _tags_IHaveTags: IHaveTags;
    _reportURL: string;

    _portfolioSettingsChanged: BehaviorSubject<EventPortfolioBO>;
    _customerType: string;

    userContext: PAusrContext;
    userEvents: number[];

    _eventMetrics: { [wb_plan_id: number]: any[] };


    private ecEvents: EventCollection;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ("dbContext" in this.CreateOptions) {
            this.dbContext = this.CreateOptions.dbContext;
        }

        this.userContext = PAEnvironment.getValue(PAEnvironment.UserContext);
        this.Identity = new IdentityProvider({ id: 0, name: "New Event Portfolio" });

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider("Loading", this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_EventPortfolio = null;

        this.peaCount = 0;
        this.bmCount = 0;
        this._portfolioEventsChanged = new BehaviorSubject<EventPortfolioBO>(undefined);
        this._linkedAnalysesChanged = new BehaviorSubject<EventPortfolioBO>(undefined);
        this.ProcessProgressProvider = new ProgressProvider("Running", this);

        this._bShowEDLP = false;
        this._bShowEDLC = false;
        this._bShowShipper = false;
        this._bShowSpecialPack = false;
        this._bShowMerch = false;
        this._bShowOther = false;
        this._bShowMerch = false;

        this._tags_IHaveTags = new TagBag();
        this._reportURL = "";
        this._portfolioSettingsChanged = new BehaviorSubject<EventPortfolioBO>(undefined);
        this._customerType = "";
        this.userEvents = [];
        this._eventMetrics = {};

        this.IHaveSecurity_init();

    }

    get WB_EventPortfolio(): WB_EventPortfolioRow {
        return this.drWB_EventPortfolio;
    }

    get PortfolioSettingsChanged(): BehaviorSubject<EventPortfolioBO> {
        return this._portfolioSettingsChanged;
    }

    LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating Event Portfolio");
        let mruService = new MDUsageService();
        this._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            self.LoadOptions = options || {};

            if ("dbContext" in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();


            if (_.isEmpty(this.ecEvents)) {
                this.ecEvents = new EventCollection({ dbContext: self.dbContext });
            }

            if (this.dbContext == null) {
                let sError = "Unable to determine dbContext for new Event Portfolio.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext

            self.dbContext.createRecordWithKey(esWB_Event_Portfolio)
                .then((newEventPortfolioRow: WB_EventPortfolioRow) => {
                    newEventPortfolioRow.setDefaults();
                    self.drWB_EventPortfolio = newEventPortfolioRow;
                    return mruService.getSalesOrgUsage();
                })
                .then((saleOrgId: number) => {
                    self.drWB_EventPortfolio.cif.WB_SALESORG_ID = saleOrgId;
                    self.dbContext.add(esWB_Event_Portfolio, self.drWB_EventPortfolio);
                    return self._AfterBoLoadCompleteInternal();
                })
                .then((ignore) => {
                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);
                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err);
                    error(err);
                });
        });

        return this._OnLoadComplete;
    }

    Load(anId: number, options?: object): Promise<IBusinessObject> {
        const self = this;

        let recordResolver: ESRecordResolver;
        let recordResolverLoadPromise: Promise<void>;

        self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");
        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            if (self.bIsLoaded) {
                let sError = "Event Portfolio already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            self.LoadOptions = options || {};
            if ("dbContext" in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (_.isEmpty(self.dbContext))
                self.dbContext = new PAdbContext({});

            if (_.isEmpty(self.dbContext)) {
                let sError = "Unable to determine dbContext for Event Portfolio.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            if (_.isEmpty(this.ecEvents)) {
                this.ecEvents = new EventCollection({ dbContext: self.dbContext });
            }

            if ("RecordResolver" in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver;
                recordResolverLoadPromise = ASync.resolve();
            } else {
                recordResolver = EventPortfolioBO.createRecordResolver({ dbContext: self.dbContext });
                recordResolverLoadPromise = EventPortfolioBO.setupRecordResolver(recordResolver, [anId]);
            }

            recordResolverLoadPromise
                .then(function() {
                    let newEventPortfolioRow: any = recordResolver.get(esWB_Event_Portfolio, anId);

                    if (_.isEmpty(newEventPortfolioRow)) {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }
                    self.drWB_EventPortfolio = newEventPortfolioRow;
                    return self._AfterBoLoadCompleteInternal();
                })
                .then((newEventPortfolioRow: any) => {
                    if (_.isNumber(self.drWB_EventPortfolio.cif.WB_SALESORG_ID) && self.drWB_EventPortfolio.cif.WB_SALESORG_ID > 0) {
                        let mruService = new MDUsageService();
                        return mruService.saveSalesOrgUsage(self.drWB_EventPortfolio.cif.WB_SALESORG_ID);
                    }
                })
                .then(() => {
                    return self.ecEvents.loadEvents(self.userEvents);
                })
                .then(() => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    self.PortfolioEventsChanged.next(self);
                    resolve(self);
                })
                .catch((err: any) => {
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    error(err);
                });

        });
        return this._OnLoadComplete;
    }


    Reload(opts?: any): Promise<IBusinessObject> {
        const self = this;

        return new Promise<IBusinessObject>((resolve, error) => {

            if (!self.bIsLoaded) {
                error("Reload: Modeling Session not loaded");
                return;
            }

            let id = self.WB_EventPortfolio.cif.WB_EVT_PORTFOLIO_ID;

            self.dbContext.purgeCache(esWB_Event_Portfolio, self.WB_EventPortfolio, {})
                .then((ignore) => {
                    self._bIsLoaded = false;
                    self._OnLoadComplete = undefined;

                    return self.Load(id, { dbContext: self.dbContext });
                })
                .then((aBO) => {
                    if (!aBO.bIsLoaded) {
                        console.log("Unable to Load BO in Reload function");
                    }

                    self.PortfolioEventsChanged.next(self);
                    resolve(self);
                })
                .catch((err) => {
                    error(err);
                });
        });

    }

    async _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;
        let iDocUrl = "";

        self.Identity.setAll(self.WB_EventPortfolio.cif.WB_EVT_PORTFOLIO_ID, self.WB_EventPortfolio.cif.PORTFOLIO_ID, self.WB_EventPortfolio.cif.PORTFOLIO_NAME, self.WB_EventPortfolio.cif.WB_AUTHUSR_ID_CREATEDBY);
        if (!_.isEmpty(self.drWB_EventPortfolio.WB_SalesOrgRow))
            self.Identity.salesOrg = self.drWB_EventPortfolio.WB_SalesOrgRow.cif.SALESORG_NAME + "(" + self.drWB_EventPortfolio.WB_SalesOrgRow.cif.SALESORG_ID + ")";
        self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
        self.Identity.listenToRecordUpdates(self.WB_EventPortfolio, "WB_EVT_PORTFOLIO_ID", "PORTFOLIO_ID", "PORTFOLIO_NAME");
        self.Identity.enableRecordWriteBack(self.WB_EventPortfolio, undefined, "PORTFOLIO_NAME");

        await self.getPEAEventCount(_.map(_.filter(self.drWB_EventPortfolio.WB_EventPortfolioEventTypeRelationshipRows, row=>row.isActive), "WB_EventTypeRow"), "0", false);

        let aConn: WB_ConnectionRow = undefined;
        let aRpt: WB_ReportTileRow[] = await self.dbContext.findAll(esWB_ReportTile, { where: { REPORT_ID: "PEA_PORTFOLIO" } });

        if (aRpt.length) {
            let rptRow = aRpt[0];
            iDocUrl = JSON.parse(rptRow.cif.RENDER_OPTIONS).iDocId || "";
            aConn = await self.dbContext.find(esWB_Connection, rptRow.cif.WB_CONNECTION_ID);
        }

        if (!_.isEmpty(aConn)) {
            let ConnectionURL = JSON.parse(aConn.cif.CONNECTION_OPTIONS).url || "";
            self._reportURL = ConnectionURL.replace("%iDocID%", iDocUrl);
        }

        await self.IHaveSecurity_OnLoadComplete();


        if (self.PolicyCollection["Editor"].bIsEditor || this.userContext.hasRoleId("VIEW_ALL"))
            self.userEvents = _.map(_.filter(self.WB_EventPortfolio.WB_EventPortfolioRelationshipRows, aRow => aRow.isActive), "WB_EVT_ID");
        else
            await self.addSecurity();

        await self._tags_IHaveTags.OnIHaveTagsLoaded;
        let portfolioTags: WB_TagRow[] = _.filter(self._tags_IHaveTags.AllTags, aTag => aTag.isActive && aTag.cif.TAG_ID.indexOf("PEA_ANALYSIS") >= 0);
        let portfolioTagIds: number[] = _.map(portfolioTags, "WB_TAG_ID");
        _.forEach(self.PortfolioEvents, aRow => {
            let eventTags: number[] = _.map(_.filter(aRow.WB_EventRow?.WB_Event_TagRows, aRow => aRow.isActive), "WB_TAG_ID");
            let eventPortfolioTags = _.filter(eventTags, aTag => _.includes(portfolioTagIds, aTag));
            if (eventPortfolioTags.length)
                aRow.cif.ANALYSIS_TYPE = _.first(_.filter(portfolioTags, (aTag: WB_TagRow) => aTag.cif.WB_TAG_ID == eventPortfolioTags[0])).cif.TAG_ID;
            else
                aRow.cif.ANALYSIS_TYPE = "PEA_ANALYSIS_OTHER";
        });

        await self.LoadEventMetrics();
        self.peaCount = self.PortfolioEvents.length;

        if (self.PortfolioEvents.length && !_.isEmpty(self.Changes())) {
            await self.Save({ bIgnoreUser: true });
        }
    }

    get ReportURL(): string {
        return this._reportURL;
    }

    get EventMetrics(): { [wb_plan_id: number]: any[] } {
        return this._eventMetrics;
    }

    async LoadEventMetrics(): Promise<{ [wb_plan_id: number]: any[] }> {
        let edlcEvents = _.filter(this.WB_EventPortfolio.WB_EventPortfolioRelationshipRows, aRow => aRow.isActive && aRow.cif.ANALYSIS_TYPE == "PEA_ANALYSIS_EDLC");
        let planIds: number[] = [];
        _.forEach(edlcEvents, anEvent => {
            planIds.push(anEvent.WB_EventRow.cif.WB_PLAN_ID);
        });
        planIds = _.uniq(planIds);

        if (planIds.length) {
            let metricRows = await PASearch.find("vUI_Portfolio_EDLC_Metrics", { WB_PLAN_ID: { inq: planIds } }, { WB_PLAN_ID: { type: "int" } }, [], 0, []);
            _.forEach(planIds, id => {
                this._eventMetrics[id] = _.filter(metricRows, row => Number(row["WB_PLAN_ID"]) == id);
            });
        }
        return;
    }

    async getMyPlans(): Promise<any[]> {
        let userGroups = this.userContext.UserGroups;
        let customerIds: number[] = _.map(this.userContext.Customers, "WB_CUST_ID");
        if (!customerIds.length) return [];

        let productIds = _.map(await this.dbContext.findAll(esWB_User_Group_Product, {
            where: {
                DELETED_IND: {
                    neq: "1",
                    WB_USRGRPR_ID: { inq: _.map(userGroups, "WB_USRGRP_ID") }
                }
            }
        }), "WB_PRDGRP_ID");


        if (!productIds.length) {
            let salesAreaIds: number[] = _.map(this.userContext.WB_SalesAreas, "WB_SALESAREA_ID");
            let arrProducts = await this.dbContext.findAll(esWB_Product_Group_SalesArea, {
                where: {
                    WB_SALESAREA_ID: {
                        in: salesAreaIds
                    },
                    DELETED_IND: {
                        neq: "1"
                    }
                }
            });
            productIds = _.map(arrProducts, aProd => aProd.WB_PRDGRP_ID);
        }

        let arrPlansByCust = await PASearch.find(
            "vUI_UsrGrp_Plans",
            {
                WB_CUST_ID_PLANNING: { inq: customerIds },
                WB_SALESORG_ID: this.WB_EventPortfolio.cif.WB_SALESORG_ID,
                WB_USRGRP_ID: { inq: _.map(userGroups, "WB_USRGRP_ID") }
            },
            {
                WB_CUST_ID_PLANNING: { type: "number" },
                WB_SALESORG_ID: { type: "number" },
                WB_USRGRP_ID: { type: "number" }
            },
            [],
            0,
            []);

        if (productIds.length !== 0) {
            let keyByProdId = _.keyBy(productIds, x => x);
            arrPlansByCust = _.filter(arrPlansByCust, aPlan =>
                aPlan.WB_PRDGRP_ID_PLANLEVEL in keyByProdId || aPlan.WB_PRDGRP_ID_PLANLEVEL == 0
            );
        }
        return arrPlansByCust;
    }

    async addSecurity(): Promise<void> {
        let self = this;
        let eventIds = _.map(_.filter(self.WB_EventPortfolio.WB_EventPortfolioRelationshipRows, aRow => aRow.isActive), "WB_EVT_ID");

        let plans = await this.getMyPlans();
        if (eventIds.length) {
            let events: any[] = _.map(await self.dbContext.findAll(esWB_Event, {
                    where: {
                        WB_EVT_ID: { inq: eventIds },
                        DELETED_IND: { neq: "1" },
                        WB_PLAN_ID: { inq: _.uniq(_.map(plans, "WB_PLAN_ID")) }
                    }
                }),
                anEvent => {
                    return {
                        "WB_EVT_ID": anEvent.cif.WB_EVT_ID,
                        "WB_CUST_ID_PLANNING": anEvent.cif.WB_CUST_ID_PLANNING
                    };
                });
            self.userEvents = _.map(events, "WB_EVT_ID");
        } else {
            self.userEvents = [];
        }
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        if (this._bIsLoaded) {
            return ASync.resolve(this);
        }
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    get EventCollection(): EventCollection {
        return this.ecEvents;
    }

    get bShowMerch(): boolean {
        this._bShowMerch = _.filter(this.PortfolioEvents, aRow => aRow.isActive && aRow.cif.ANALYSIS_TYPE == "PEA_ANALYSIS_MERCH").length > 0 ? true : false;
        return this._bShowMerch;
    }

    get bShowEDLP(): boolean {
        this._bShowEDLP = _.filter(this.PortfolioEvents, aRow => aRow.isActive && aRow.cif.ANALYSIS_TYPE == "PEA_ANALYSIS_EDLP").length > 0 ? true : false;
        return this._bShowEDLP;
    }

    get bShowEDLC(): boolean {
        this._bShowEDLC = _.filter(this.PortfolioEvents, aRow => aRow.isActive && aRow.cif.ANALYSIS_TYPE == "PEA_ANALYSIS_EDLC").length > 0 ? true : false;
        return this._bShowEDLC;
    }

    get bShowShipper(): boolean {
        this._bShowShipper = _.filter(this.PortfolioEvents, aRow => aRow.isActive && aRow.cif.ANALYSIS_TYPE == "PEA_ANALYSIS_SHIPPER").length > 0 ? true : false;
        return this._bShowShipper;
    }

    get bShowSpecialPack(): boolean {
        this._bShowSpecialPack = _.filter(this.PortfolioEvents, aRow => aRow.isActive && aRow.cif.ANALYSIS_TYPE == "PEA_ANALYSIS_SPECIAL_PACK").length > 0 ? true : false;
        return this._bShowSpecialPack;
    }

    get bShowOther(): boolean {
        this._bShowOther = _.filter(this.PortfolioEvents, aRow => aRow.isActive && !_.includes(["PEA_ANALYSIS_EDLP", "PEA_ANALYSIS_EDLC", "PEA_ANALYSIS_SHIPPER", "PEA_ANALYSIS_SPECIAL_PACK", "PEA_ANALYSIS_MERCH"], aRow.cif.ANALYSIS_TYPE)).length > 0 ? true : false;
        return this._bShowOther;
    }

    get Taggable(): IHaveTags {
        return this._tags_IHaveTags;
    }


    async Validate(options?: any): Promise<IBusinessObject> {

        let self = this;
        if ("bSkipValidation" in options && options.bSkipValidation)
            return;

        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_EventPortfolio.cif.PORTFOLIO_NAME + "(" + self.WB_EventPortfolio.cif.PORTFOLIO_ID + ")");
        self.ValidateOptions = options || {};
        try {
            if (self.dbContext == undefined) {
                let sError = "Unable to determine dbContext to Validate Simulation Input.";
                self.ValidateProgressProvider.exception(sError);
                self._bIsValidated = false;
                return self;
            }
            if (self.WB_EventPortfolio.isActive)
                await EventPortfolioBOValidation.ValidateFields(self);

            self._bIsValidated = self.ValidateMessageProvider.countMessages(MessageType.Error) <= 0;
            self.ValidateProgressProvider.finish();
        } catch (err) {
            self._bIsValidated = false;
            self.ValidateProgressProvider.exception(err);
            return self;
        }

        return self;

    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options);
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options);
    }

    private async SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        const self = this;
        self.SaveOptions = options || {};

        if (!self.PolicyCollection["Editor"].bIsEditor && !(("bIgnoreUser" in options) && options.bIgnoreUser))
            return self;


        const wbEventPortfolio = <IwbEventPortfolio>self.drWB_EventPortfolio;
        this.SaveProgressProvider.start("Saving " + wbEventPortfolio.PORTFOLIO_NAME + "(" + wbEventPortfolio.PORTFOLIO_ID + ")");

        try {
            if (_.isEmpty(self.dbContext)) {
                self._bIsSaved = false;
                let sError = "Unable to determine dbContext to Save Event Portfolio.";
                self.SaveProgressProvider.exception(sError);
                return self;
            }

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>;
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext);
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext);
            }

            await self.Validate({});

            if (!self.bIsValidated) {
                self._bIsSaved = false;
                self.SaveProgressProvider.finish();
                return self;
            }
            if (self.drWB_EventPortfolio.bChanged) {
                self.WB_EventPortfolio.cif.MODIFIED_DTTS = DateUtils.convertToSAPBWTs(new Date());
            }
            let tasks: Promise<any> [] = [];
            tasks.push(saveFunction(esWB_Event_Portfolio, self.drWB_EventPortfolio, {}));
            tasks.push(saveFunction(esWB_Event_Portfolio_Customer_Relationship,
                self.WB_EventPortfolio.WB_EventPortfolioCustomerRelationshipRows));
            tasks.push(saveFunction(esWB_Event_Portfolio_Product_Relationship,
                self.WB_EventPortfolio.WB_EventPortfolioProductRelationshipRows));
            tasks.push(saveFunction(esWB_Event_Portfolio_Period_Relationship,
                self.WB_EventPortfolio.WB_EventPortfolioPeriodRelationshipRows));
            tasks.push(saveFunction(esWB_Event_Portfolio_Tag_Relationship,
                self.WB_EventPortfolio.WB_EventPortfolioTagRelationshipRows));
            tasks.push(saveFunction(esWB_Event_Portfolio_EventType_Relationship,
                self.WB_EventPortfolio.WB_EventPortfolioEventTypeRelationshipRows));
            tasks.push(saveFunction(esWB_Event_Portfolio_Relationship,
                self.WB_EventPortfolio.WB_EventPortfolioRelationshipRows));
            tasks.push(saveFunction(esWB_Event_Portfolio_LinkedAnalysis,
                self.WB_EventPortfolio.WB_EventPortfolioLinkedAnalysisRows));
            _.forEach(self.WB_EventPortfolio.WB_EventPortfolioLinkedAnalysisRows, (aRow: WB_EventPortfolioLinkedAnalysisRow) => {
                tasks.push(saveFunction(esWB_Event_Portfolio_LinkedAnalysis_Relationship, aRow.WB_EventPortfolioLinkedAnalysisRelationshipRows));
            });


            _.forEach(self.EventCollection.Events, anEvent => {
                let changeSet = anEvent.Changes();
                if (_.filter(changeSet.Changes, aChange => aChange.Message.indexOf("WB_EvtFR") > 0).length)
                    tasks.push(anEvent.Save({ Validate: { bSkipAllValidations: true } }));
            });
            await Promise.all(tasks);

            if (bBatch) {
                self.dbContext.addBatchCompleteListener(() => {
                    self._bIsSaved = true;
                });
            } else {
                self._bIsSaved = true;
            }
            self.SaveProgressProvider.finish();
            if (self.drWB_EventPortfolio.bChanged) {
                self.userEvents = _.map(_.filter(self.WB_EventPortfolio.WB_EventPortfolioRelationshipRows, aRow => aRow.isActive), "WB_EVT_ID");
                self.PortfolioEventsChanged.next(self);
            }
        } catch (err) {
            self._bIsSaved = false;
            self.SaveProgressProvider.exception(err);

        }
        return self;
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Copy
    Copy(options?: any): Promise<IBusinessObject> {


        const self: EventPortfolioBO = this;

        let copyOptions = _.defaultsDeep({}, self.CopyOptions, { wbPortfolioId: self.WB_EventPortfolio.cif.WB_EVT_PORTFOLIO_ID });

        return new Promise<EventPortfolioBO>(async (resolve, error) => {
            let newTargetBO = new EventPortfolioBO({
                dbContext: self.dbContext
            });

            try {
                await newTargetBO.LoadNew({
                    dbContext: self.dbContext
                });

                RecordUtils.CopyProperties(self.dbContext, esWB_Event_Portfolio,
                    self.WB_EventPortfolio, newTargetBO.WB_EventPortfolio,
                    [],
                    ["PORTFOLIO_ID", "CREATED_DTTS", "MODIFIED_DTTS", "DELETED_DT", "DELETED_IND", "WB_AUTHUSR_ID_CREATEDBY"],
                    {});

                newTargetBO.WB_EventPortfolio.cif.PORTFOLIO_NAME = "Copy_of_" + self.WB_EventPortfolio.cif.PORTFOLIO_NAME;
                newTargetBO.WB_EventPortfolio.cif.PORTFOLIO_COMMENTS = newTargetBO.WB_EventPortfolio.cif.PORTFOLIO_NAME;
                for (let aRow of self.WB_EventPortfolio.WB_EventPortfolioEventTypeRelationshipRows) {
                    if (aRow.isActive)
                        await newTargetBO.addEventTypeRelationship(aRow.cif.WB_EVTTYPE_ID);
                }

                for (let aRow of self.WB_EventPortfolio.WB_EventPortfolioPeriodRelationshipRows) {
                    if (aRow.isActive)
                        await newTargetBO.addPeriodRelationship(aRow.cif.WB_PERIOD_ID, aRow.cif.BENCHMARK_IND);
                }

                if (self.WB_EventPortfolio.cif.WB_AUTHUSR_ID_CREATEDBY != newTargetBO.WB_EventPortfolio.cif.WB_AUTHUSR_ID_CREATEDBY) {
                    let planningCustomers = _.map(newTargetBO.userContext.Customers, "WB_CUST_ID");
                    let custHId = newTargetBO.WB_EventPortfolio.cif.WB_CUSTH_ID;
                    for (let aRow of self.WB_EventPortfolio.WB_EventPortfolioCustomerRelationshipRows) {
                        if (aRow.isActive) {
                            let startDate = DateUtils.convertFromSAPBW("18000101");
                            let endDate = DateUtils.convertFromSAPBW("99991231");
                            let wbCustChildrenIds = await CustomerHierarchyService.getChildren(custHId, aRow.cif.WB_CUST_ID, startDate, endDate, newTargetBO._customerType);
                            if (_.filter(wbCustChildrenIds, aCust => _.includes(planningCustomers, aCust)).length)
                                await newTargetBO.addCustomerRelationship(aRow.cif.WB_CUST_ID, aRow.cif.BENCHMARK_IND);
                        }
                    }
                } else {
                    for (let aRow of self.WB_EventPortfolio.WB_EventPortfolioCustomerRelationshipRows) {
                        if (aRow.isActive) {
                            await newTargetBO.addCustomerRelationship(aRow.cif.WB_CUST_ID, aRow.cif.BENCHMARK_IND);
                        }
                    }
                }


                for (let aRow of self.WB_EventPortfolio.WB_EventPortfolioProductRelationshipRows) {
                    if (aRow.isActive)
                        await newTargetBO.addProductRelationship(aRow.cif.WB_PRDGRP_ID, aRow.cif.BENCHMARK_IND);
                }

                for (let aRow of self.WB_EventPortfolio.WB_EventPortfolioTagRelationshipRows) {
                    if (aRow.isActive)
                        await newTargetBO.addTagRelationship(aRow.cif.WB_TAG_ID, aRow.cif.BENCHMARK_IND);
                }
                resolve(newTargetBO);
            } catch (err) {
                console.log("ModelCoefficientSetBO creation failed:");
                console.log(err);
                error(err);
            }
        });

    }

    //
    Changes(options?: IBusinessObjectChangesOptions): IBusinessObjectChanges {
        let opts = options || {};
        opts.dctExcludeFields = opts.dctExcludeFields || {};
        opts.bIgnoreStandardFields = true;
        opts.dctIgnoreChanges = opts.dctIgnoreChanges || {};

        // Set any BO Specific change settings
        let changeSet = DefaultChanges(this, this.WB_EventPortfolio, opts);
        let changeSets: any[] = [];
        if (!_.isEmpty(changeSet) && changeSet?.bHasChanges)
            changeSets = _.concat(changeSet.Changes, changeSets);

        let ec = this.EventCollection.Events;
        if (!_.isEmpty(ec)) {
            _.forEach(ec, anEvent => {
                changeSet = anEvent.Changes({ changeCountThreshold: 5, bIncludeFieldDetails: true });
                let edlcPromoChange = _.filter(changeSet.Changes, aChange => aChange.Message.indexOf("WB_EvtFR") > 0);

                if (edlcPromoChange.length) {
                    changeSets = _.concat(changeSets, [{ Message: "Changes detected in Event " + anEvent.Identity.name + "(" + anEvent.Identity.id_ui + "): " }]);
                    changeSets = _.concat(changeSets, edlcPromoChange);
                }
            });
        }
        if (changeSets.length)
            return { bHasChanges: true, Changes: changeSets, bMainRecordExists: true };
        else
            return undefined;

    }


    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options);
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options);
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;
        const wbEventPortfolio = <IwbEventPortfolio>self.drWB_EventPortfolio;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbEventPortfolio.PORTFOLIO_NAME + "(" + wbEventPortfolio.PORTFOLIO_ID + ")");

        return new Promise<IBusinessObject>((resolve, error) => {

            // 1. Validate if we can delete the Event Portfolio

            // 2. If Valid, mark all the records for deletion.
            self.drWB_EventPortfolio.markDeleted();
            _.forEach(self.WB_EventPortfolio.WB_EventPortfolioRelationshipRows, aRow => {
                if (aRow.isActive)
                    aRow.markDeleted();
            });
            _.forEach(self.WB_EventPortfolio.WB_EventPortfolioEventTypeRelationshipRows, aRow => {
                if (aRow.isActive)
                    aRow.markDeleted();
            });
            _.forEach(self.WB_EventPortfolio.WB_EventPortfolioCustomerRelationshipRows, aRow => {
                if (aRow.isActive)
                    aRow.markDeleted();
            });
            _.forEach(self.WB_EventPortfolio.WB_EventPortfolioProductRelationshipRows, aRow => {
                if (aRow.isActive)
                    aRow.markDeleted();
            });
            _.forEach(self.WB_EventPortfolio.WB_EventPortfolioPeriodRelationshipRows, aRow => {
                if (aRow.isActive)
                    aRow.markDeleted();
            });
            _.forEach(self.WB_EventPortfolio.WB_EventPortfolioTagRelationshipRows, aRow => {
                if (aRow.isActive)
                    aRow.markDeleted();
            });

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);
                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err);
                        resolve(self);
                    });
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>


    //<editor-fold desc = "IEvent Portfolio">

    //</editor-fold>


    //<editor-fold desc = "IEvent Portfolio Customers">
    addCustomerRelationship(aWbCustId: number, benchmark: string): Promise<EventPortfolioBO> {
        const self = this;
        return new Promise<EventPortfolioBO>((resolve, error) => {

            // create new records
            let checkIfExisting = _.filter(self.WB_EventPortfolio.WB_EventPortfolioCustomerRelationshipRows,
                (aRow: WB_EventPortfolioCustomerRelationshipRow) =>
                    aRow.cif.WB_CUST_ID == aWbCustId && aRow.cif.BENCHMARK_IND == benchmark && aRow.isActive
            );
            if (checkIfExisting.length > 0) {
                resolve(self);
                return;
            }

            let aCustRow: WB_CustomerRow = undefined;
            self.dbContext.find(esWB_Customer, aWbCustId)
                .then((aWB_Customer: WB_CustomerRow) => {
                    if (_.isEmpty(aWB_Customer)) {
                        error("Unable to Find Customer with Id:" + aWbCustId);
                        return;
                    }
                    aCustRow = aWB_Customer;
                    // create record
                    return self.dbContext.createRecordWithKey(esWB_Event_Portfolio_Customer_Relationship);
                }).then((aNewRow: WB_EventPortfolioCustomerRelationshipRow) => {
                aNewRow.setDefaults();
                aNewRow.cif.WB_CUST_ID = aWbCustId;
                aNewRow.cif.WB_EVT_PORTFOLIO_ID = self.drWB_EventPortfolio.cif.WB_EVT_PORTFOLIO_ID;
                aNewRow.cif.BENCHMARK_IND = benchmark;

                aNewRow.WB_CustomerRow = aCustRow;

                self.dbContext.add(esWB_Event_Portfolio_Customer_Relationship, aNewRow);
                self._portfolioSettingsChanged.next(self);
                resolve(self);
            })
                .catch((err) => {
                    error(err);
                });

        });
    }

    removeCustomerRelationship(aWBCustRId: number, aWBCustId?: number, options?: any): Promise<EventPortfolioBO> {
        var self = this;

        return new Promise<EventPortfolioBO>((resolve, error) => {

            if (aWBCustRId > 0) {
                _.forEach(self.drWB_EventPortfolio.WB_EventPortfolioCustomerRelationshipRows, (aCustRRow: WB_EventPortfolioCustomerRelationshipRow) => {
                    if (aCustRRow.isActive && aCustRRow.cif.WB_EVT_PORTFOLIOCR_ID == aWBCustRId) {
                        aCustRRow.markDeleted();
                        self._portfolioSettingsChanged.next(self);
                    }
                });
            } else {
                if (aWBCustId > 0) {
                    _.forEach(self.drWB_EventPortfolio.WB_EventPortfolioCustomerRelationshipRows, (aCustRRow: WB_EventPortfolioCustomerRelationshipRow) => {
                        if (aCustRRow.isActive && aCustRRow.cif.WB_CUST_ID == aWBCustId) {
                            aCustRRow.markDeleted();
                            self._portfolioSettingsChanged.next(self);
                        }
                    });
                }

            }


            resolve(self);
        });
    }

    //</editor-fold>


    //<editor-fold desc = "IEvent Portfolio Products">
    addProductRelationship(aWbPrdId: number, benchmark: string): Promise<EventPortfolioBO> {
        const self = this;
        return new Promise<EventPortfolioBO>((resolve, error) => {

            let checkIfProdExisting = _.filter(self.WB_EventPortfolio.WB_EventPortfolioProductRelationshipRows,
                (aRow: WB_EventPortfolioProductRelationshipRow) =>
                    aRow.cif.WB_PRDGRP_ID == aWbPrdId && aRow.cif.BENCHMARK_IND == benchmark && aRow.isActive
            );
            if (checkIfProdExisting.length > 0) {
                resolve(self);
                return;
            }
            // create new records
            let aProdRow: WB_ProductGroupRow = undefined;
            self.dbContext.find(esWB_Product_Group, aWbPrdId)
                .then((aWB_Product_Group: WB_ProductGroupRow) => {
                    if (_.isEmpty(aWB_Product_Group)) {
                        error("Unable to Find Customer with Id:" + aWbPrdId);
                        return;
                    }
                    aProdRow = aWB_Product_Group;
                    // create record
                    return self.dbContext.createRecordWithKey(esWB_Event_Portfolio_Product_Relationship);
                }).then((aNewRow: WB_EventPortfolioProductRelationshipRow) => {
                aNewRow.setDefaults();
                aNewRow.cif.WB_PRDGRP_ID = aWbPrdId;
                aNewRow.cif.WB_EVT_PORTFOLIO_ID = self.drWB_EventPortfolio.cif.WB_EVT_PORTFOLIO_ID;
                aNewRow.cif.BENCHMARK_IND = benchmark;
                aNewRow.WB_ProductGroupRow = aProdRow;
                self.dbContext.add(esWB_Event_Portfolio_Product_Relationship, aNewRow);
                self._portfolioSettingsChanged.next(self);
                resolve(self);
            })
                .catch((err) => {
                    error(err);
                });

        });
    }


    removeProductRelationship(aWBProdRId: number, aWBProdId?: number, options?: any): Promise<EventPortfolioBO> {
        var self = this;

        return new Promise<EventPortfolioBO>((resolve, error) => {

            if (aWBProdRId > 0) {
                _.forEach(self.drWB_EventPortfolio.WB_EventPortfolioProductRelationshipRows, (aProdRRow: WB_EventPortfolioProductRelationshipRow) => {
                    if (aProdRRow.isActive && aProdRRow.cif.WB_EVT_PORTFOLIOPR_ID == aWBProdRId) {
                        aProdRRow.markDeleted();
                        self._portfolioSettingsChanged.next(self);
                    }
                });
            } else {
                if (aWBProdId > 0) {
                    _.forEach(self.drWB_EventPortfolio.WB_EventPortfolioProductRelationshipRows, (aProdRRow: WB_EventPortfolioProductRelationshipRow) => {
                        if (aProdRRow.isActive && aProdRRow.cif.WB_PRDGRP_ID == aWBProdId) {
                            aProdRRow.markDeleted();
                            self._portfolioSettingsChanged.next(self);
                        }
                    });
                }
            }

            resolve(self);
        });
    }


    //</editor-fold>

    //<editor-fold desc = "IEvent Portfolio Tags">

    addTagRelationship(aWbTagId: number, benchmark: string): Promise<WB_EventPortfolioTagRelationshipRow> {
        const self = this;
        return new Promise<WB_EventPortfolioTagRelationshipRow>((resolve, error) => {
            if (_.isEmpty(benchmark)) {
                resolve(undefined);
                return;
            }
            // create new records
            let checkIfTagExisting = _.filter(self.WB_EventPortfolio.WB_EventPortfolioTagRelationshipRows,
                (aRow: WB_EventPortfolioTagRelationshipRow) =>
                    aRow.cif.WB_TAG_ID == aWbTagId && aRow.cif.BENCHMARK_IND == benchmark
            );
            if (checkIfTagExisting.length > 0) {
                let aRow = _.first(checkIfTagExisting);
                if (aRow.cif.DELETED_IND == "1") {
                    aRow.cif.DELETED_IND = "0";
                }

                resolve(aRow);
                return;
            }

            let aTagRow: WB_TagRow = undefined;
            self.dbContext.find(esWB_Tag, aWbTagId)
                .then((aWB_Tag: WB_TagRow) => {
                    if (_.isEmpty(aWB_Tag)) {
                        error("Unable to Find Tag with Id:" + aWbTagId);
                        return;
                    }
                    aTagRow = aWB_Tag;
                    // create record
                    return self.dbContext.createRecordWithKey(esWB_Event_Portfolio_Tag_Relationship);
                })
                .then((aNewRow: WB_EventPortfolioTagRelationshipRow) => {
                    aNewRow.setDefaults();
                    aNewRow.cif.WB_TAG_ID = aWbTagId;
                    aNewRow.cif.WB_EVT_PORTFOLIO_ID = self.drWB_EventPortfolio.cif.WB_EVT_PORTFOLIO_ID;
                    aNewRow.cif.BENCHMARK_IND = benchmark;

                    aNewRow.WB_TagRow = aTagRow;
                    self.dbContext.add(esWB_Event_Portfolio_Tag_Relationship, aNewRow);
                    resolve(aNewRow);
                })
                .catch((err) => {
                    error(err);
                });

        });
    }

    removeTagRelationship(aWBTagRId: number, options?: any): Promise<EventPortfolioBO> {
        var self = this;

        return new Promise<EventPortfolioBO>((resolve, error) => {

            _.forEach(self.drWB_EventPortfolio.WB_EventPortfolioTagRelationshipRows, (aTagRRow: WB_EventPortfolioTagRelationshipRow) => {
                if (aTagRRow.isActive && aTagRRow.cif.WB_EVT_PORTFOLIOTGR_ID == aWBTagRId) {
                    aTagRRow.markDeleted();
                }
            });
            resolve(self);
        });
    }


    //</editor-fold>


    //<editor-fold desc = "IEvent Portfolio Periods">
    addPeriodRelationship(aWbPeriodId: number, benchmark: string): Promise<EventPortfolioBO> {
        const self = this;
        return new Promise<EventPortfolioBO>((resolve, error) => {

            // create new records
            let checkIfPeriodExisting = _.filter(self.WB_EventPortfolio.WB_EventPortfolioPeriodRelationshipRows,
                (aRow: WB_EventPortfolioPeriodRelationshipRow) =>
                    aRow.cif.WB_PERIOD_ID == aWbPeriodId && aRow.cif.BENCHMARK_IND == benchmark && aRow.isActive
            );
            if (checkIfPeriodExisting.length > 0) {
                resolve(self);
                return;
            }

            let aPeriodRow: WB_PeriodRow = undefined;
            self.dbContext.find(esWB_Period, aWbPeriodId)
                .then((aWB_Period: WB_PeriodRow) => {
                    if (_.isEmpty(aWB_Period)) {
                        error("Unable to Find Period with Id:" + aWbPeriodId);
                        return;
                    }
                    aPeriodRow = aWB_Period;
                    // create record
                    return self.dbContext.createRecordWithKey(esWB_Event_Portfolio_Period_Relationship);
                }).then((aNewRow: WB_EventPortfolioPeriodRelationshipRow) => {
                aNewRow.setDefaults();
                aNewRow.cif.WB_PERIOD_ID = aWbPeriodId;
                aNewRow.cif.WB_EVT_PORTFOLIO_ID = self.drWB_EventPortfolio.cif.WB_EVT_PORTFOLIO_ID;
                aNewRow.cif.BENCHMARK_IND = benchmark;
                aNewRow.WB_PeriodRow = aPeriodRow;
                self.dbContext.add(esWB_Event_Portfolio_Period_Relationship, aNewRow);
                self._portfolioSettingsChanged.next(self);
                resolve(self);
            })
                .catch((err) => {
                    error(err);
                });

        });
    }

    removePeriodRelationship(aWBPeriodRId: number, aWBPeriodId?: number, options?: any): Promise<EventPortfolioBO> {
        var self = this;

        return new Promise<EventPortfolioBO>((resolve, error) => {

            if (aWBPeriodRId > 0) {
                _.forEach(self.drWB_EventPortfolio.WB_EventPortfolioPeriodRelationshipRows, (aPeriodRRow: WB_EventPortfolioPeriodRelationshipRow) => {
                    if (aPeriodRRow.isActive && aPeriodRRow.cif.WB_EVT_PORTFOLIOTR_ID == aWBPeriodRId) {
                        aPeriodRRow.markDeleted();
                        self._portfolioSettingsChanged.next(self);
                    }
                });
            } else {
                if (aWBPeriodId > 0) {
                    _.forEach(self.drWB_EventPortfolio.WB_EventPortfolioPeriodRelationshipRows, (aPeriodRRow: WB_EventPortfolioPeriodRelationshipRow) => {
                        if (aPeriodRRow.isActive && aPeriodRRow.cif.WB_PERIOD_ID == aWBPeriodId) {
                            aPeriodRRow.markDeleted();
                            self._portfolioSettingsChanged.next(self);
                        }
                    });
                }
            }


            resolve(self);
        });
    }

    //</editor-fold>

    //<editor-fold desc = "IEvent Portfolio Event Type">
    addEventTypeRelationship(aWbEventTypeId: number): Promise<EventPortfolioBO> {
        const self = this;
        return new Promise<EventPortfolioBO>((resolve, error) => {

            // create new records
            let aEventTypeRow: WB_EventTypeRow = undefined;
            self.dbContext.find(esWB_Event_Type, aWbEventTypeId)
                .then((aWB_EventType: WB_EventTypeRow) => {
                    if (_.isEmpty(aWB_EventType)) {
                        error("Unable to Find Event Type with Id:" + aWbEventTypeId);
                        return;
                    }
                    aEventTypeRow = aWB_EventType;
                    // create record
                    return self.dbContext.createRecordWithKey(esWB_Event_Portfolio_EventType_Relationship);
                })
                .then((aNewRow: WB_EventPortfolioEventTypeRelationshipRow) => {
                    aNewRow.setDefaults();
                    aNewRow.cif.WB_EVTTYPE_ID = aWbEventTypeId;
                    aNewRow.cif.WB_EVT_PORTFOLIO_ID = self.drWB_EventPortfolio.cif.WB_EVT_PORTFOLIO_ID;
                    aNewRow.WB_EventTypeRow = aEventTypeRow;
                    self.dbContext.add(esWB_Event_Portfolio_EventType_Relationship, aNewRow);
                    resolve(self);
                })
                .catch((err) => {
                    error(err);
                });

        });
    }

    removeEventTypeRelationship(aWBEvtTypeRId: number, options?: any): Promise<EventPortfolioBO> {
        var self = this;

        return new Promise<EventPortfolioBO>((resolve, error) => {

            _.forEach(self.drWB_EventPortfolio.WB_EventPortfolioEventTypeRelationshipRows, (aEvtTypeRRow: WB_EventPortfolioEventTypeRelationshipRow) => {
                if (aEvtTypeRRow.isActive && aEvtTypeRRow.cif.WB_EVT_PORTFOLIOETR_ID == aWBEvtTypeRId) {
                    aEvtTypeRRow.markDeleted();
                }
            });

            resolve(self);
        });
    }

    //</editor-fold>

    //<editor-fold desc = "IEvent Portfolio Linked Analysis">

    private _linkedAnalysesChanged: BehaviorSubject<EventPortfolioBO>;

    get LinkedAnalysesChanged(): BehaviorSubject<EventPortfolioBO> {
        return this._linkedAnalysesChanged;
    }

    addLinkedAnalysis(sName: string): Promise<EventPortfolioBO> {
        const self = this;
        return new Promise<EventPortfolioBO>((resolve, error) => {

            // create new records
            self.dbContext.createRecordWithKey(esWB_Event_Portfolio_LinkedAnalysis)
                .then((aNewRow: WB_EventPortfolioLinkedAnalysisRow) => {
                    aNewRow.setDefaults();
                    aNewRow.cif.LINKED_ANALYSIS_NAME = sName;
                    aNewRow.cif.WB_EVT_PORTFOLIO_ID = self.drWB_EventPortfolio.cif.WB_EVT_PORTFOLIO_ID;
                    self.dbContext.add(esWB_Event_Portfolio_LinkedAnalysis, aNewRow);
                    self.LinkedAnalysesChanged.next(self);
                    resolve(self);
                })
                .catch((err) => {
                    error(err);
                });

        });
    }


    removeLinkedAnalysis(aWBLAId: number, options?: any): Promise<EventPortfolioBO> {
        var self = this;

        return new Promise<EventPortfolioBO>((resolve, error) => {

            _.forEach(self.drWB_EventPortfolio.WB_EventPortfolioLinkedAnalysisRows, (aLARow: WB_EventPortfolioLinkedAnalysisRow) => {
                if (aLARow.isActive && aLARow.cif.WB_EVT_PORTFOLIOLA_ID == aWBLAId) {
                    aLARow.markDeleted();
                    self.LinkedAnalysesChanged.next(self);
                }
            });

            resolve(self);
        });
    }

    addLinkedAnalysisR(wbEvtId: number, wbLAId: number): Promise<EventPortfolioBO> {
        const self = this;
        return new Promise<EventPortfolioBO>((resolve, error) => {

            // create new records
            self.dbContext.createRecordWithKey(esWB_Event_Portfolio_LinkedAnalysis_Relationship)
                .then((aNewRow: WB_EventPortfolioLinkedAnalysisRelationshipRow) => {
                    aNewRow.setDefaults();
                    aNewRow.cif.WB_EVT_PORTFOLIOLA_ID = wbLAId;
                    aNewRow.cif.WB_EVT_ID = wbEvtId;
                    self.dbContext.add(esWB_Event_Portfolio_LinkedAnalysis_Relationship, aNewRow);
                    resolve(self);
                })
                .catch((err) => {
                    error(err);
                });

        });
    }

    removeLinkedAnalysisR(wbEvtId: number, wbLAId: number, options?: any): Promise<EventPortfolioBO> {
        var self = this;

        return new Promise<EventPortfolioBO>((resolve, error) => {
            let aLinkedAnalysisRow = _.first(_.filter(self.drWB_EventPortfolio.WB_EventPortfolioLinkedAnalysisRows, aRow => aRow.cif.WB_EVT_PORTFOLIOLA_ID == wbLAId));

            _.forEach(aLinkedAnalysisRow.WB_EventPortfolioLinkedAnalysisRelationshipRows, (aLARRow: WB_EventPortfolioLinkedAnalysisRelationshipRow) => {
                if (aLARRow.isActive && aLARRow.cif.WB_EVT_ID == wbEvtId) {
                    aLARRow.markDeleted();
                    //self._portfolioSettingsChanged.next(self)
                }
            });

            resolve(self);
        });
    }


    //</editor-fold>

    private _portfolioEventsChanged: BehaviorSubject<EventPortfolioBO>;

    get EventPortfolio(): EventPortfolioBO {
        return this;
    }

    get peaFinalCount(): number {
        return this.peaCount;
    }

    set peaFinalCount(count: number) {
        this.peaCount = count;
    }

    get bmFinalCount(): number {
        return this.bmCount;
    }

    set bmFinalCount(count: number) {
        this.bmCount = count;
    }

    get PortfolioEvents(): WB_EventPortfolioRelationshipRow[] {
        const self = this;
        let arrEventPortfolioRelRows: WB_EventPortfolioRelationshipRow[] =
            _.filter(self.WB_EventPortfolio.WB_EventPortfolioRelationshipRows,
                (aRelRow: WB_EventPortfolioRelationshipRow) => aRelRow.isActive
                    && _.includes(self.userEvents, aRelRow.cif.WB_EVT_ID)
            );

        return arrEventPortfolioRelRows;
    }

    async getPEAEventCount(eventTypeRows: WB_EventTypeRow[], bmInd: string, bSave: boolean) {
        const self = this;
        let prgs = self.ProcessProgressProvider;
        prgs.start("Event Search");
        prgs.setPercentComplete(0.1);
        let portfolioBO: EventPortfolioBO = self;

        let eventPortfolioRow: WB_EventPortfolioRow = portfolioBO.WB_EventPortfolio;

        let custHId = eventPortfolioRow.cif.WB_CUSTH_ID;
        let prdHId = eventPortfolioRow.cif.WB_PRDH_ID;

        let peaEventTypes = _.map(eventTypeRows, (evtType: WB_EventTypeRow) => evtType.cif.WB_EVTTYPE_ID);

        //get PEA customer Ids
        let peaCustIds = _.map(_.filter(portfolioBO.WB_EventPortfolio.WB_EventPortfolioCustomerRelationshipRows, (evtCust: WB_EventPortfolioCustomerRelationshipRow) => evtCust.cif.BENCHMARK_IND === bmInd && evtCust.isActive), (evtCust: WB_EventPortfolioCustomerRelationshipRow) => evtCust.cif.WB_CUST_ID);

        //get PEA Product Group Ids
        let peaPrdGrpIds = _.map(_.filter(portfolioBO.WB_EventPortfolio.WB_EventPortfolioProductRelationshipRows, (evtPrd: WB_EventPortfolioProductRelationshipRow) => evtPrd.cif.BENCHMARK_IND === bmInd && evtPrd.isActive), (evtProd: WB_EventPortfolioProductRelationshipRow) => evtProd.cif.WB_PRDGRP_ID);

        //get PEA Period Ids
        let peaPeriodIds = _.map(_.filter(portfolioBO.WB_EventPortfolio.WB_EventPortfolioPeriodRelationshipRows, (evtPeriod: WB_EventPortfolioPeriodRelationshipRow) => evtPeriod.cif.BENCHMARK_IND === bmInd && evtPeriod.isActive), (evtPeriod: WB_EventPortfolioPeriodRelationshipRow) => evtPeriod.cif.WB_PERIOD_ID);

        if (peaCustIds.length == 0 || peaPrdGrpIds.length == 0 || peaPeriodIds.length == 0) {
            await self.EventPortfolioEventRel_Sync([]);
            prgs.finish();
            return;
        }

        let minStartDt = DateUtils.getMinSAPBWDate();
        let maxEndDt = DateUtils.getMaxSAPBWDate();
        let periodRows: WB_PeriodRow[] = [];
        if (peaPeriodIds.length > 0) {
            periodRows = <WB_PeriodRow[]>await self.dbContext.findUsingCache(esWB_Period, peaPeriodIds);

            minStartDt = _.minBy(periodRows, (aPeriod: WB_PeriodRow) => aPeriod.cif.PERIOD_START_DT)?.cif?.PERIOD_START_DT;
            maxEndDt = _.maxBy(periodRows, (aPeriod: WB_PeriodRow) => aPeriod.cif.PERIOD_END_DT)?.cif?.PERIOD_END_DT;
        }

        //get PEA Tag Ids
        let peaTagIds = _.map(_.filter(portfolioBO.WB_EventPortfolio.WB_EventPortfolioTagRelationshipRows, (evtTag: WB_EventPortfolioTagRelationshipRow) => evtTag.cif.BENCHMARK_IND === bmInd && evtTag.isActive), (evtTag: WB_EventPortfolioTagRelationshipRow) => evtTag.cif.WB_TAG_ID);

        prgs.setPercentComplete(0.15);
        prgs.setProgressMessage("findCustomers", "Search: Finding Customers");
        //get All Customers according to the hierarchy selected
        let peaCustKeyList: any = await self.getAllCustomers(custHId, peaCustIds);

        prgs.setPercentComplete(0.20);
        prgs.setProgressMessage("findProducts", "Search: Finding Products");
        //get All Products according to the hierarchy selected
        let peaPrdList: any = await self.getAllProducts(prdHId, peaPrdGrpIds);

        //get Events
        prgs.setProgressMessage("findEvents", "Search: Finding Events");
        let arrEvents = await self.getEvents(peaCustKeyList, peaPrdList, peaEventTypes, periodRows, minStartDt, maxEndDt, peaTagIds);
        let arrEvtIds: number[] = _.uniq(_.map(arrEvents, (aRes: any) => aRes.WB_EVT_ID));
        prgs.setPercentComplete(0.50);

        if (bmInd == "1")
            self.bmCount = arrEvtIds.length;
        else {
            self.peaCount = arrEvtIds.length;
            prgs.setProgressMessage("syncEvents", "Search: Synchronizing Events");
            await self.EventPortfolioEventRel_Sync(arrEvtIds, bSave);
            prgs.setPercentComplete(0.90);
        }
        prgs.setPercentComplete(1);
        prgs.finish();
    }

    async getEvents(arrCustIds: number[], arrPrdIds: number[], arrEvtTypeIds: number[], arrPeriods: WB_PeriodRow[], startDate: string, endDate: string, arrTagIds: string[] | number[]): Promise<any[]> {
        let self = this;
        let arrDateRanges: IDateRange[] = [];
        let query: { WB_CUST_ID_PLANNING?: { [op: string]: number[] }, WB_PROD_ID?: { [op: string]: number[] }, EVENT_TYPE_ID?: { [op: string]: number[] } } = {};
        let fieldSpec: { [field: string]: { type: string } } = {};

        if (arrCustIds.length > 0) {
            query.WB_CUST_ID_PLANNING = { inq: arrCustIds };
            fieldSpec.WB_CUST_ID_PLANNING = { type: "number" };
        }

        if (arrPrdIds.length > 0) {
            query.WB_PROD_ID = { inq: arrPrdIds };
            fieldSpec.WB_PROD_ID = { type: "number" };
        }

        if (arrPeriods.length > 0) {
            fieldSpec.WB_PERIOD_ID = { type: "number" };

            _.forEach(arrPeriods, (aPrd: WB_PeriodRow) => {
                let startDt = DateUtils.convertFromSAPBW(aPrd.cif.PERIOD_START_DT);
                let endDt = DateUtils.convertFromSAPBW(aPrd.cif.PERIOD_END_DT);
                let dateRange = DateUtils.createDateRange(startDt, endDt);
                arrDateRanges.push(dateRange);
            });
        }

        if (arrEvtTypeIds.length > 0) {
            query.EVENT_TYPE_ID = { inq: arrEvtTypeIds };
            fieldSpec.EVENT_TYPE_ID = { type: "number" };
        }


        let events: any[] = [];
        let filteredEvents: any[] = [];
        let tagGroups: WB_TagRelationshipRow[] = [];
        let tagFlatQuery: any[] = [];

        if (arrTagIds.length) {
            tagGroups = await self.dbContext.findAll(esWB_Tag_Relationship, { where: { WB_TAG_ID: { inq: arrTagIds } } });
        }

        if (tagGroups.length) {
            let group = 0;
            let idsInGroup: number[] = [];

            _.forEach(_.orderBy(tagGroups, ["WB_TAG_ID_PRNT", "WB_TAG_ID"]), (aTag: WB_TagRelationshipRow) => {
                if (group != aTag.cif.WB_TAG_ID_PRNT) {
                    if (group > 0)
                        tagFlatQuery.push(idsInGroup);
                    group = aTag.cif.WB_TAG_ID_PRNT;
                    idsInGroup = [];
                }
                idsInGroup.push(aTag.cif.WB_TAG_ID);
            });
            if (idsInGroup.length)
                tagFlatQuery.push(idsInGroup);

        }

        let distinctFields = ["WB_EVT_ID"];
        if (tagFlatQuery.length)
            distinctFields.push("WB_TAG_ID");

        if (arrPeriods.length > 0) {
            distinctFields.push("INSTORE_START_DT");
            distinctFields.push("INSTORE_END_DT");
        }

        let results: any[] = await PASearch.find(
            "vUI_Portfolio_Event_Search",
            query,
            fieldSpec,
            [],
            0,
            distinctFields);

        events = results;
        let eventIds = _.uniq(_.map(results, "WB_EVT_ID"));
        if (tagFlatQuery.length) {
            let i = 0;
            while (i < tagFlatQuery.length && events.length) {
                events = _.filter(results, anEvent => _.includes(tagFlatQuery[i], anEvent.WB_TAG_ID) && _.includes(eventIds, anEvent.WB_EVT_ID));
                eventIds = _.uniq(_.map(events, "WB_EVT_ID"));
                i++;
            }
        }
        results = _.uniqBy(events, "WB_EVT_ID");
        if (arrPeriods.length > 0) {
            //filtering the data according to the selected periods ranges
            _.forEach(results, (aRes: any) => {
                let inStoreStartDt = DateUtils.convertFromSAPBW(aRes.INSTORE_START_DT);
                let inStoreEndDt = DateUtils.convertFromSAPBW(aRes.INSTORE_END_DT);
                let inStoreDateRange = DateUtils.createDateRange(inStoreStartDt, inStoreEndDt);

                let rangeOverlaps = _.first(_.filter(arrDateRanges, (aDateRange: IDateRange) => DateUtils.RangesOverlap(aDateRange, inStoreDateRange)));
                if (rangeOverlaps)
                    filteredEvents.push(aRes);
            });
        } else
            filteredEvents = results;

        return filteredEvents;
    }

    async getAllCustomers(aWbCustHId: number, arrCustIds: number[]): Promise<number[] | string[]> {
        const self = this;
        return new Promise(async (resolve, reject) => {

            if (aWbCustHId == 0 || _.isEmpty(arrCustIds)) {
                resolve([]);
            }

            //  let customerType: any[] = await PASearch.find('vUI_Event_Portfolio_CustomerType', {WB_CUSTH_ID: aWbCustHId}, {WB_CUSTH_ID: {type: "number"}}, [], 1, [])
            //  if (customerType.length)
            //      self._customerType = customerType[0].CUSTOMER_TYPE


            let startDate = DateUtils.convertFromSAPBW("18000101");
            let endDate = DateUtils.convertFromSAPBW("99991231");

            let dctCustomerHierarchyList: { [id: number]: number } = {};
            let userCustomers = _.map(_.filter(self.userContext.Customers, row => row.cif.PLANNING_CUSTOMER_IND == "1"), "WB_CUST_ID");

            for (let custId of arrCustIds) {
                dctCustomerHierarchyList[custId] = custId;

                let wbCustChildrenIds = await CustomerHierarchyService.getChildren(aWbCustHId, custId, startDate, endDate, self._customerType);
                if (wbCustChildrenIds.length) {

                    _.forEach(wbCustChildrenIds, (a: any) => {
                        if (_.includes(userCustomers, a))
                            dctCustomerHierarchyList[a] = a;
                    });
                    console.log(dctCustomerHierarchyList, "dct");
                }
            }
            resolve(_.keys(dctCustomerHierarchyList));
        });


    }

    async getAllProducts(aWbPrdHId: number, arrPrdIds: number[]): Promise<number[] | string[]> {
        const self = this;

        return new Promise<number[] | string[]>(async (resolve, error) => {

            if (aWbPrdHId == 0 || _.isEmpty(arrPrdIds)) {
                resolve([]);
            }

            let startDate = DateUtils.convertFromSAPBW("18000101");
            let endDate = DateUtils.convertFromSAPBW("99991231");

            let dctProductHierarchyList: { [id: number]: number } = {};

            for (let wbProdId of arrPrdIds) {
                dctProductHierarchyList[wbProdId] = wbProdId;
                let wbPrdChildrenIds = await ProductHierarchyService.getChildren(aWbPrdHId, wbProdId, startDate, endDate, "Product");
                if (wbPrdChildrenIds.length) {
                    _.forEach(wbPrdChildrenIds, (a: any) => {
                        dctProductHierarchyList[a] = a;
                    });
                    console.log(dctProductHierarchyList, "dct");
                }
            }
            resolve(_.keys(dctProductHierarchyList));
        });
    }

    async EventPortfolioEventRel_Sync(evtIds: any[], bSave?: boolean): Promise<void> {
        const self = this;
        let dctEvts = _.keyBy(evtIds, (x) => x);
        let dctEvts_Missing = _.clone(dctEvts);
        let dctEvts_Existing: { [wbEvtId: number]: number } = {};
        if (evtIds.length)
            await self.dbContext.findUsingCache(esWB_Event, evtIds);

        _.forEach(self.WB_EventPortfolio.WB_EventPortfolioRelationshipRows, (aRow) => {
            if (!aRow.isActive)
                return;

            let wbEvtId = _.toNumber(aRow.cif.WB_EVT_ID);
            if (wbEvtId in dctEvts_Existing) {
                aRow.markDeleted();
                return;
            }

            if (!(wbEvtId in dctEvts)) {
                aRow.markDeleted();
            }
            dctEvts_Existing[wbEvtId] = wbEvtId;
            delete dctEvts_Missing[wbEvtId];

        });

        for (let evtId of _.values(dctEvts_Missing)) {
            await self.addEventPortfolioRelation(evtId);
        }

        let currentEvents = _.map(_.filter(self.WB_EventPortfolio.WB_EventPortfolioRelationshipRows, aRow => aRow.isActive), "WB_EVT_ID");
        let bDiff = _.difference(currentEvents, self.userEvents).length > 0 || _.difference(self.userEvents, currentEvents).length > 0;

        if (bSave && bDiff) {
            self.WB_EventPortfolio.bChanged = true;
        }
    }


    async addEventPortfolioRelation(wbEvtId: number): Promise<EventPortfolioBO> {
        const self = this;

        return new Promise<EventPortfolioBO>((resolve, error) => {

            let eventRow: WB_EventRow = undefined;
            let tag: string = "";
            let found: WB_EventPortfolioRelationshipRow = undefined;

            _.forEach(self.WB_EventPortfolio.WB_EventPortfolioRelationshipRows, aRow => {
                if (aRow.isActive && aRow.cif.WB_EVT_ID == wbEvtId) {
                    found = aRow;
                    return;
                }
            });
            if (!_.isEmpty(found)) {
                resolve(self);
                return;
            }

            self.dbContext.findUsingCache(esWB_Event, [wbEvtId], {})
                .then((anEvt: WB_EventRow[]) => {
                    if (_.isEmpty(anEvt))
                        return;
                    eventRow = _.first(anEvt);
                    return self.getAnalysisTag(wbEvtId);
                })
                .then((analysisTag: string) => {
                    tag = analysisTag;
                    return self.dbContext.createRecordWithKey(esWB_Event_Portfolio_Relationship);
                })
                .then((aNewRow: WB_EventPortfolioRelationshipRow) => {
                    aNewRow.setDefaults();
                    aNewRow.cif.WB_EVT_ID = wbEvtId;
                    aNewRow.cif.WB_EVT_PORTFOLIO_ID = self.drWB_EventPortfolio.cif.WB_EVT_PORTFOLIO_ID;
                    aNewRow.WB_EventRow = eventRow;
                    aNewRow.cif.ANALYSIS_TYPE = tag;
                    self.dbContext.add(esWB_Event_Portfolio_Relationship, aNewRow);
                    resolve(self);
                })
                .catch((err) => {
                    error(err);
                });

        });
    }

    async getAnalysisTag(wbEvtId: number): Promise<string> {
        let self = this;
        return new Promise<string>((resolve, error) => {
            let tag: string = "";
            self.dbContext.findAll(esWB_Event_Tag, {
                where: {
                    WB_EVT_ID: wbEvtId,
                    DELETED_IND: { neq: "1" }
                }
            })
                .then((tagRows: WB_EventTagRow[]) => {
                    let portfolioTags: WB_TagRow[] = _.filter(self._tags_IHaveTags.AllTags, aTag => aTag.isActive && aTag.cif.TAG_ID.indexOf("PEA_ANALYSIS") >= 0);
                    let analysisTags: WB_EventTagRow[] = _.filter(tagRows, aTagRow => _.includes(_.map(portfolioTags, "WB_TAG_ID"), aTagRow.cif.WB_TAG_ID));
                    if (analysisTags.length)
                        tag = _.first(_.filter(portfolioTags, aTag => aTag.cif.WB_TAG_ID == analysisTags[0].cif.WB_TAG_ID)).cif.TAG_ID;
                    else
                        tag = "PEA_ANALYSIS_OTHER";
                    resolve(tag);
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    async updateAnalysisType(): Promise<void> {
        let self = this;
        for (let i = 0; i < self.WB_EventPortfolio.WB_EventPortfolioRelationshipRows.length; i++) {
            let aRow = self.WB_EventPortfolio.WB_EventPortfolioRelationshipRows[i];
            if (aRow.isActive)
                aRow.cif.ANALYSIS_TYPE = await self.getAnalysisTag(aRow.cif.WB_EVT_ID);
        }
    }


    get PortfolioEventsChanged(): BehaviorSubject<EventPortfolioBO> {
        return this._portfolioEventsChanged;
    }

    //<editor-fold desc = "IRecordResolver operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ("dbContext" in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }

        const eventportfolio_options: CreateOptions = {
            standardConditions: {
                [esWB_Event_Portfolio]: { "DELETED_IND": { "notIn": ["1"] } },
                [esWB_Event_Portfolio_Relationship]: { "DELETED_IND": { "notIn": ["1"] } },
                [esWB_Event_Portfolio_Customer_Relationship]: { "DELETED_IND": { "notIn": ["1"] } },
                [esWB_Event_Portfolio_Period_Relationship]: { "DELETED_IND": { "notIn": ["1"] } },
                [esWB_Event_Portfolio_Product_Relationship]: { "DELETED_IND": { "notIn": ["1"] } },
                [esWB_Event_Portfolio_EventType_Relationship]: { "DELETED_IND": { "notIn": ["1"] } },
                [esWB_Event_Portfolio_Tag_Relationship]: { "DELETED_IND": { "notIn": ["1"] } }
            },
            dctIncludeBelongsToNamedRelations: {
                [esWB_Event]: [esWB_Event_Tag]
            }
        };

        const aRecResolver = new ESRecordResolver(dbContext, eventportfolio_options);

        return aRecResolver;
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_Event_Portfolio, ids).then((result) => {
                resolve();
            }).catch((err) => {
                error(err);
            });
        });
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    get EventPortfolioRows(): WB_EventPortfolioRow[] {
        return [];
    }

    updateSelectedDomains(cannId: number, overlapId: number, metricId: number) {
        const self = this;
        if (!_.isEmpty(self.drWB_EventPortfolio)) {
            if (cannId) {
                self.drWB_EventPortfolio.cif.CANNIBALIZATION_POLICY = cannId.toString();
            }
            if (overlapId) {
                self.drWB_EventPortfolio.cif.OVERLAP_HANDLING = overlapId.toString();
            }
            if (metricId) {
                self.drWB_EventPortfolio.cif.METRIC_SET = metricId.toString();
            }


        }

    }

    private _PolicyCollection: IPolicyCollection;
    private _bIHaveSecurityLoaded: boolean;
    private _OnIHaveSecurityLoaded: Promise<IHaveSecurity>;
    private _Lock: ILock;

    IHaveSecurity_init() {
        this._PolicyCollection = new PolicyCollection();
        this._bIHaveSecurityLoaded = false;
        this._OnIHaveSecurityLoaded = undefined;
        this._Lock = undefined;
    }

    IHaveSecurity_beforeReload() {
        this._bIHaveSecurityLoaded = false;
        this._OnIHaveSecurityLoaded = undefined;
    }

    IHaveSecurity_OnLoadComplete(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            self.OnIHaveSecurityLoaded
                .then((ignore) => {
                    resolve();
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    get OnIHaveSecurityLoaded(): Promise<IHaveSecurity> {
        const self = this;

        if (this.bIHaveSecurityLoaded) {
            return ASync.resolve(this);
        }

        if (this._OnIHaveSecurityLoaded) {
            return this._OnIHaveSecurityLoaded;
        }


        let returnValue = this._OnIHaveSecurityLoaded = (async (): Promise<IHaveSecurity> => {

            try {
                let extraPolicy = new EventPortfolioBOStandardPolicy(self);
                await extraPolicy.OnLoadComplete;
                self.PolicyCollection.addPolicy("Editor", extraPolicy);
                self._bIHaveSecurityLoaded = true;
                return self;
            } catch (err) {
                console.log("Unable to setup Security Policies");
                throw err;
            }
        })();

        return returnValue;
    }

    get PolicyCollection(): IPolicyCollection {
        return this._PolicyCollection;
    }

    get bIHaveSecurityLoaded(): boolean {
        return this._bIHaveSecurityLoaded;
    }


//</editor-fold>

}

PAEnvironment.registerBusinessObjectClass(EventPortfolioBO, "EventPortfolioBO", "Event Portfolio");
